
import "../css/NotificationBell.css";
import {
  FileText,
  Car,
  CreditCard,
  Briefcase,
  Building2,
  ChevronRight,
} from "lucide-react";

const iconMap = {
  contacts: <FileText size={18} />,
  bookings: <Car size={18} />,
  payments: <CreditCard size={18} />,
  applications: <Briefcase size={18} />,
  dealers: <Building2 size={18} />,
};

const colorMap = {
  contacts: "#0a2ea0",
  bookings: "#0a2ea0",
  payments: "#16a34a",
  applications: "#9333ea",
  dealers: "#ea580c",
};

export default function NotificationBell({
  notifications = [],
  open,
  onClose,
  onClick,
}) {
  if (!open) return null;

  return (
    <div className="notification-dropdown">

      <div className="notification-header">
        <div>
          <h3>Notifications</h3>
          <p>
            {notifications.length} Pending
          </p>
        </div>
      </div>

      <div className="notification-list">

        {notifications.length === 0 ? (
          <div className="notification-empty">
            <h4>No Notifications</h4>
            <p>Everything is up to date.</p>
          </div>
        ) : (
          notifications.map((item) => (
            <div
              key={item.module}
              className="notification-item"
              onClick={() => onClick(item)}
            >

              <div
                className="notification-icon"
                style={{
                  background: `${colorMap[item.module]}15`,
                  color: colorMap[item.module],
                }}
              >
                {iconMap[item.module]}
              </div>

              <div className="notification-content">

                <div className="notification-title">
                  {item.title}
                </div>

                <div className="notification-subtitle">

                  {item.count === 1
                    ? item.description
                    : `${item.count} New`}

                </div>

              </div>

              <ChevronRight
                size={18}
                className="notification-arrow"
              />

            </div>
          ))
        )}

      </div>

    </div>
  );
}